/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, FormControlLabel, RadioGroup, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
// import PageLayout from '../../Components/PageLayout';
// import DatePicker, { DateObject } from "react-multi-date-picker"
// import persian from "react-date-object/calendars/persian"
// import persian_fa from "react-date-object/locales/persian_fa"
// import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as PlusIcon } from "../../Assets/svg/PlusIcon.svg";
import { ReactComponent as DangerHome } from "../../Assets/svg/DangerHome.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as LocationIcon } from "../../Assets/svg/LocationIcon.svg";
import { ReactComponent as NeshanegozariIcon } from "../../Assets/svg/NeshanegozariIcon.svg";
import { ReactComponent as ReportIcon } from "../../Assets/svg/ReportIcon.svg";

// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
// import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
// import { NumericFormat } from 'react-number-format';
import {
    useParams, useLocation
} from "react-router-dom";
// import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import ButtonNavigation from '../../Components/ButtonNavigation';
// import PropItem from '../../Components/PropItem';
import { json, useNavigate } from 'react-router-dom';
import { ReactComponent as PersonIcon } from "../../Assets/svg/PersonIcon.svg";
import { ReactComponent as SettingDarkGray } from "../../Assets/svg/SettingDarkGray.svg";
import { ReactComponent as ArrowRightIconTransparent } from "../../Assets/svg/ArrowRightIconTransparent.svg";
import { ReactComponent as ExitIcon } from "../../Assets/svg/ExitIcon.svg";
// import { useSearchPropStore } from '../../store/searchProperty';
import Radio from '@mui/material/Radio';

import UsersDropZone from '../../Components/UsersDropZone';
import { useUserStore } from '../../store/user';
import ButtonNavigation from '../../Components/ButtonNavigation';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
import Cookies from 'js-cookie'
import { setLocationIdCookie, setUserCookie } from '../../Components/PublicFunctions';



function NewArea(props) {

    const { enqueueSnackbar } = useSnackbar();

    const [openSettingModal, setOpenSettingModal] = useState(false)
    const [openLocalModal, setOpenLocalModal] = useState(false)
    const [openDepositeModal, setOpenDepositeModal] = useState(false)
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [openAddUser, setOpenAddUser] = useState(false)
    const [deposit, setDeposit] = useState("")
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [Users, setUsers] = React.useState([]);
    const [ofsset, setOfsset] = React.useState(0);
    const [hasMore, setHasMore] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [propKey, setPropKey] = React.useState(0);
    const [inPlusing, setInPlusing] = React.useState(true);
    const [userImg, setUserImg] = useState(null);
    const [userFullName, setUserFullName] = useState("");
    const [userMobile, setUserMobile] = useState("");
    const [userPass, setUserPass] = useState("");
    const [areaDisplay, setAreaDisplay] = useState(1);
    const [deleteAreaModal, setDeleteAreaModal] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [newArea, setNewArea] = useState("");
    const [createAreaLoading, setCreateAreaLoading] = useState(false);
    const [ofssetFlag, setOfssetFlag] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [editAreaModal, setEditAreaModal] = useState(false);
    const [editItem, setEditItem] = useState({});
    const [editLoading, setEditLoading] = useState(false);


    const navigate = useNavigate();

    const locationId = useUserStore((state) => state.locationId)


    const dataFetchedRef = useRef(false);

    function useQuery() {
        return new URLSearchParams(useLocation().search)
    }

    const query = useQuery()
    const token = query.get("token")

    const handleClickOpenSettingModal = () => {
        setOpenSettingModal(true);
    };
    const handleOpenSettingModalClose = () => {
        setOpenSettingModal(false);
    };

    const handleClickOpenLocalModal = () => {
        setOpenLocalModal(true);
    };
    const handleOpenLocalModalClose = () => {
        setOpenLocalModal(false);
    };

    const handleClickOpenDepositeModal = () => {
        setOpenDepositeModal(true);
    };
    const handleOpenDepositeModalClose = () => {
        setOpenDepositeModal(false);
    };

    const handleClickOpenAddUserModal = () => {
        setOpenAddUser(true);
    };
    const handleOpenAddUserModalClose = () => {
        setOpenAddUser(false);
    };

    const handleClickOpenDeleteAreaModal = (id) => {
        setDeleteId(id)
        setDeleteAreaModal(true);
    };
    const handleDeleteAreaModalClose = () => {
        setDeleteAreaModal(false);
    };

    const handleClickOpenUsersModal = () => {
        setTimeout(function () {
            if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
                return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };
    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };


    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleEditAreaModalOpen = (id, name) => {
        setEditItem({
            "Id": id,
            "Name": name,
        })
        setEditAreaModal(true);
    };
    const handleEditAreaModalClose = () => {
        setEditAreaModal(false);
    };






    const getUsers = (resetState = false) => {
        if (resetState) {
            setUsers([])
            console.log("reset", Users)
            setPropKey(propKey => propKey++)
            setOfsset(0);
            setHasMore(true)
        }

        setUsersLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/webapp/my_agencies",
                method: "POST",
                data: {
                    "Limit": 10,
                    "Offset": ofsset
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("users", res.data.result.agencies);

                const tmpProp = [...Users]
                if (res.data.result.agencies.length > 0) {
                    if (!resetState) {
                        res.data.result.agencies.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setUsers(tmpProp)

                        setPropKey(propKey => propKey++)
                    }
                    else
                        setUsers(res.data.result.agencies)


                    setPropKey(propKey => propKey++)

                } else {
                    console.log("End")
                    setHasMore(false)
                    if (resetState) setUsers([])

                }

                console.log("users ff", Users)
                setUsersLoading(false)
                setTimeout(function () { setInPlusing(true) }, 1000)
            });

        } catch (e) {
            console.error(e);
            setUsersLoading(false)

        }


    }


    const onScroll = () => {
        if (document.getElementById("dashboard-content")) {

            const scrollTop = document.getElementById("dashboard-content").scrollTop
            const scrollHeight = document.getElementById("dashboard-content").scrollHeight
            const clientHeight = document.getElementById("dashboard-content").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && inPlusing) {
                setOfsset(ofsset => ofsset + 10);
                // setSearchData({"name":"Offset","value":ofsset})
                console.log("ofsset", ofsset)
                setInPlusing(false)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
                return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
            }
        }, 500)


    }, [Users])

    useEffect(() => {
        console.log("offset use")

        if (hasMore && Users.length) {
            getUsers()
        }
    }, [ofsset])


    const getAgency = async () => {
        try {
            const res = await http({
                // url of the api endpoint (can be changed)
                url: "/authenticate/get/agency",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            console.log("agency", res)

            if (res.data.result) {
                localStorage.setItem('token', token)
                setTokenCookie(token)
                localStorage.setItem('locationId', res.data.result.LocationId)
                setLocationIdCookie(res.data.result.LocationId)
                localStorage.setItem('locationName', res.data.result.LocationName)
                Cookies.set('locationName', res.data.result.LocationName)
                localStorage.setItem('agency', JSON.stringify(res.data.result))
                setUserCookie(res.data.result)
            }
            else {
                navigate("/login")
                const variant = 'error'
                enqueueSnackbar("احراز هویت انجام نشد.", { variant });
            }

            handleCloseBackdrop()

        } catch (e) {
            navigate("/login")
            const variant = 'error'
            enqueueSnackbar("احراز هویت انجام نشد.", { variant });
        }
    }

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        handleToggleBackdrop()

        console.log("new area page")

        getAgency()



    }, [])


    const handleLogOut = () => {
        localStorage.removeItem("token")
        localStorage.removeItem("provinces")
        localStorage.removeItem("agency")
        navigate("/login")
    }


    //Areas Pagination

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);
    const [areasItems, setAreasItems] = React.useState([]);

    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {
            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 20);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    // useEffect(() => {
    //   console.log("hasMoreOffset",hasMoreOffset)
    // }, [hasMoreOffset])

    useEffect(() => {
        console.log("offset use sdfsd", areaOfsset)
        console.log("ofssetFlag", ofssetFlag)
        console.log("hasMoreOffset", hasMoreOffset)
        console.log("areasItems.length", areasItems.length)

        if (hasMoreOffset && areasItems.length && !ofssetFlag) {
            console.log("testsr", areaOfsset)
            if (areaDisplay == "1")
                getAreas(false, "", "/webapp/divar_areas/list")
            if (areaDisplay == "2")
                getAreas(false, "", "/areas/list")
        }

        if (ofssetFlag) {
            let url = ""
            if (areaDisplay == "1")
                url = "/webapp/divar_areas/list"
            if (areaDisplay == "2")
                url = "/areas/list"


            const data = {
                "LocationId": locationId,
                "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Offset": 0,
                "Limit": 20
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempAreas = [...areasItems]
                    if (res.data.result.items.length > 0) {

                        setAreasItems(res.data.result.items)

                        console.log("areasItems", areasItems)


                    } else {
                        console.log("End")
                        setHasMoreOffset(false)
                        if (resetState) setAreasItems([])

                    }
                    setTimeout(function () { setAreaInPlusing(true) }, 3000)
                    setOfssetFlag(false)
                    setAreasLoading(false)


                });
            } catch (e) {
                console.error(e);
                setAreasLoading(false)
            }

        }


    }, [areaOfsset])

    useEffect(() => {
        console.log("offset use sdfsd", areaOfsset)
        console.log("ofssetFlag", ofssetFlag)


        if (ofssetFlag) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)

            let url = ""
            if (areaDisplay == "1")
                url = "/webapp/divar_areas/list"
            if (areaDisplay == "2")
                url = "/areas/list"


            const data = {
                "LocationId": locationId,
                "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Offset": 0,
                "Limit": 20
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempAreas = [...areasItems]
                    if (res.data.result.items.length > 0) {

                        setAreasItems(res.data.result.items)

                        console.log("areasItems", areasItems)


                    } else {
                        if (isDelete) {
                            setAreasItems(res.data.result.items)
                            setIsDelete(false)
                        } else {
                            console.log("End")
                            setHasMoreOffset(false)
                            // if (resetState) setAreasItems([])
                        }


                    }
                    setTimeout(function () { setAreaInPlusing(true) }, 3000)
                    setOfssetFlag(false)
                    setAreasLoading(false)


                });
            } catch (e) {
                console.error(e);
                setAreasLoading(false)
            }

        }


    }, [ofssetFlag])



    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
            console.log("offse", areaOfsset)
        }


        setAreasLoading(true)


        const data = {
            "LocationId": Cookies.get('locationId'),
            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 20
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 3000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }

    useEffect(() => {
        console.log("areaDisplay", areaDisplay)
        // setAreaOfsset(0)
        setOfssetFlag(true)
        // if (areaDisplay == "1")
        //     getAreas(true, "", "/webapp/divar_areas/list")
        // if (areaDisplay == "2")
        //     getAreas(true, "", "/areas/list")

    }, [areaDisplay])
    ///////////////////////

    const deleteArea = () => {
        console.log("deleteId", deleteId)
        console.log("token", Cookies.get('token'))

        setDeleteLading(true)
        try {
            http({
                url: "/areas/delete",
                method: "POST",
                data: {
                    "Id": parseInt(deleteId)
                },
                headers: {

                    "Authorization": `Bearer ${Cookies.get('token')}`

                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)
                setIsDelete(true)
                setAreaOfsset(0);
                setDeleteId("")
                handleDeleteAreaModalClose()
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده مورد نظر با موفقیت حذف شد.", { variant });
                }
                setDeleteLading(false)


            });
        } catch (e) {
            console.error(e);
            setDeleteLading(false)

        }
    }

    const createArea = () => {
        console.log("newArea", newArea)

        setCreateAreaLoading(true)
        try {
            http({
                url: "/areas/create",
                method: "POST",
                data: {
                    "Name": newArea,
                    "LocationId": locationId
                },
                headers: {

                    "Authorization": `Bearer ${Cookies.get('token')}`

                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)

                setAreaOfsset(0);

                setNewArea("")
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده با موفقیت اضافه شد.", { variant });
                }
                setCreateAreaLoading(false)

                // setTimeout(function () { getAreas(true, "", "/areas/list") }, 500)

            });
        } catch (e) {
            console.error(e);
            setCreateAreaLoading(false)

        }
    }

    const handleChangeEditItems = (name) => {
        let tmp = { ...editItem }
        tmp.Name = name
        setEditItem(tmp)
    }

    const handleEdit = () => {
        handleToggleBackdrop()


        try {
            http({
                url: "/areas/update",
                method: "POST",
                data: {
                    ...editItem,
                    LocationId: locationId
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)

                setAreaOfsset(0);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده با موفقیت ویرایش شد.", { variant });
                }
                handleEditAreaModalClose()
                handleCloseBackdrop()
            });
        } catch (e) {
            console.error(e);
            handleCloseBackdrop()
        }
    }

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999, backgroundColor: "#828282" }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>


            <Box sx={{ p: 1 }}>
                <Box sx={{ overflowX: 'hidden', p: 1 }}>
                    <RadioGroup
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        name="position"
                        defaultValue="end"
                        className='text-gray-f-13'
                        value={areaDisplay}
                    >
                        <FormControlLabel value={1} control={<Radio size="small" sx={{
                            color: '#29A19C', '&.Mui-checked': {
                                color: '#29A19C',
                            },
                        }} />} label="می خواهم ازمحدوده های پایش استفاده کنم" onChange={() => setAreaDisplay(1)} />
                        <FormControlLabel value={2} control={<Radio size="small" sx={{
                            color: '#29A19C', '&.Mui-checked': {
                                color: '#29A19C',
                            },
                        }} />} label="می خواهم ازمحدوده های خودم استفاده کنم" onChange={() => setAreaDisplay(2)} />
                    </RadioGroup>
                    {areaDisplay == 1 ? <Box>
                        <Typography component='p' sx={{ color: '#666666', fontSize: '14px', textAlign: 'center', mt: 2 }}>
                            محدوده های پیشنهادی پایش
                        </Typography>
                        <Box sx={{ mt: 3, color: '#8F8F8F' }}>

                            <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 170px)!important", overflow: 'auto' }} id="areas-container">
                                <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                    {
                                        areasItems && areasItems.length > 0 ?
                                            areasItems.map((item, index) => (

                                                <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                    <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                    <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center' }}>
                                                        <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                        {/* <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                            <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton>
                                                        </div> */}
                                                    </label>
                                                </Box>
                                            ))
                                            : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                    }
                                    {
                                        areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box> : null}
                    {areaDisplay == 2 ? <Box>

                        <Box sx={{ mt: 3, color: '#8F8F8F' }}>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase id='newAreas' value={newArea} onChange={(e) => setNewArea(e.target.value)} placeholder='محدوده دلخواه خود را وارد کنید' />
                            </Box>
                            <Button className='green-btn' onClick={createArea} sx={{ width: "100%", mx: 'auto', borderRadius: "25px", mt: 2 }}>
                                {!createAreaLoading ? "افزودن محدوده" : <img src="/assets/img/ladng2.gif" width="40" />}
                            </Button>
                            <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 230px)!important", overflow: 'auto' }} id="areas-container">
                                <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                    {
                                        areasItems && areasItems.length > 0 ?
                                            areasItems.map((item, index) => (

                                                <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                    <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                    <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'right' }}>
                                                        <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                        <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                            <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton onClick={() => handleEditAreaModalOpen(item.id, item.Name)}>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton>
                                                        </div>
                                                    </label>
                                                </Box>
                                            ))
                                            : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                    }
                                    {
                                        areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box> : null}
                </Box>
            </Box>



            {openLocalModal && <Dialog className="dialog-box"
                fullScreen
                open={openLocalModal}
                onClose={handleOpenLocalModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto', fontSize: '13px' }} variant="h6" component="div">
                            انتخاب محدوده
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenLocalModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ overflowX: 'hidden', p: 1 }}>
                    <RadioGroup
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        name="position"
                        defaultValue="end"
                        className='text-gray-f-13'
                        value={areaDisplay}
                    >
                        <FormControlLabel value={1} control={<Radio size="small" sx={{
                            color: '#29A19C', '&.Mui-checked': {
                                color: '#29A19C',
                            },
                        }} />} label="می خواهم ازمحدوده های پایش استفاده کنم" onChange={() => setAreaDisplay(1)} />
                        <FormControlLabel value={2} control={<Radio size="small" sx={{
                            color: '#29A19C', '&.Mui-checked': {
                                color: '#29A19C',
                            },
                        }} />} label="می خواهم ازمحدوده های خودم استفاده کنم" onChange={() => setAreaDisplay(2)} />
                    </RadioGroup>
                    {areaDisplay == 1 ? <Box>
                        <Typography component='p' sx={{ color: '#666666', fontSize: '14px', textAlign: 'center', mt: 2 }}>
                            محدوده های پیشنهادی پایش
                        </Typography>
                        <Box sx={{ mt: 3, color: '#8F8F8F' }}>

                            <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 220px)!important", overflow: 'auto' }} id="areas-container">
                                <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                    {
                                        areasItems && areasItems.length > 0 ?
                                            areasItems.map((item, index) => (

                                                <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                    <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                    <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center' }}>
                                                        <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                        {/* <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                            <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton>
                                                        </div> */}
                                                    </label>
                                                </Box>
                                            ))
                                            : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                    }
                                    {
                                        areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box> : null}
                    {areaDisplay == 2 ? <Box>

                        <Box sx={{ mt: 3, color: '#8F8F8F' }}>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase id='newAreas' value={newArea} onChange={(e) => setNewArea(e.target.value)} placeholder='محدوده دلخواه خود را وارد کنید' />
                            </Box>
                            <Button className='green-btn' onClick={createArea} sx={{ width: "100%", mx: 'auto', borderRadius: "25px", mt: 2 }}>
                                {!createAreaLoading ? "افزودن محدوده" : <img src="/assets/img/ladng2.gif" width="40" />}
                            </Button>
                            <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 300px)!important", overflow: 'auto' }} id="areas-container">
                                <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                    {
                                        areasItems && areasItems.length > 0 ?
                                            areasItems.map((item, index) => (

                                                <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                    <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                    <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'right' }}>
                                                        <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                        <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                            <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton onClick={() => handleEditAreaModalOpen(item.id, item.Name)}>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton>
                                                        </div>
                                                    </label>
                                                </Box>
                                            ))
                                            : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                    }
                                    {
                                        areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box> : null}
                </Box>
                {/* <Button
                    onClick={handleOpenLocalModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
            </Dialog>}





            {deleteAreaModal && <Dialog className="dialog-box"
                open={deleteAreaModal}
                onClose={handleDeleteAreaModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        آیا میخواهید این محدوده را حذف کنید؟
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteAreaModalClose}>خیر</Button>
                    <Button onClick={deleteArea} autoFocus>
                        {!deleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                    </Button>
                </DialogActions>
            </Dialog>}

            {editAreaModal && <Dialog className="dialog-box"
                fullScreen
                open={editAreaModal}
                onClose={handleEditAreaModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            ویرایش محدوده
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleEditAreaModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                    <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase id='deposit' value={editItem.Name} onChange={(e) => handleChangeEditItems(e.target.value)} placeholder='عنوان محدوده را وارد کنید' />
                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleEdit} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}
        </>
    );
}

export default NewArea;